import script from "./ProfileView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileView.vue?vue&type=script&lang=ts&setup=true"

import "./ProfileView.vue?vue&type=style&index=0&id=552d9e6b&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-552d9e6b"]])

export default __exports__